import React, { useState, useEffect } from "react"
import "./MapPage.css"
import SidePanel from "../components/SidePanel"
import WorldMap from "../components/map/WorldMap"
import { useWorldData } from "../hooks/useWorldData";
import { useWorldMaps } from "../hooks/useWorldMaps";
import { useMapController } from "../hooks/useMapController"
import { useNavigate } from "react-router-dom"

const MapPage = () => {
  const [hoveredCountry, setHoveredCountry] = useState(null)
  const [lockedCountry, setLockedCountry] = useState(null)
  const [lockedRegion, setLockedRegion] = useState(null)
  const [hoveredRegion, setHoveredRegion] = useState(null)
  const [panelOpen, setPanelOpen] = useState(true)

  const { countries, regions, loading } = useWorldData()

  const {
    countryToRegion,
    availableCountries,
    countryInfo,
    regionsMap,
  } = useWorldMaps(countries, regions)

  const navigate = useNavigate()

  const {
    position,
    setPosition,
    selectedRegion,
    selectRegion,
    resetView,
    handleMoveEnd,
  } = useMapController(regions)

  useEffect(() => {
    if (selectedRegion) {
      setLockedRegion(null)
      setHoveredRegion(null)
    } else {
      setLockedCountry(null)
      setHoveredCountry(null)
    }
  }, [selectedRegion])

  const handleCountryClick = (code) => {
    const country = countryInfo[code]

    navigate(`/country/${code}`, {
      state: {
        countryName: country?.name
      }
    })
  }

  return (
    <div className="map-page">
      {/* Map */}
      <div className="map-page-canvas">
        <WorldMap
          position={position}
          setPosition={setPosition}
          selectedRegion={selectedRegion}
          selectRegion={selectRegion}
          resetView={resetView}
          handleMoveEnd={handleMoveEnd}

          hoveredRegion={hoveredRegion}
          setHoverCountry={(name, isRightClick) => {
            if (isRightClick) {
              setLockedCountry(prev => (prev === name ? null : name))
            } else {
              if (!lockedCountry) setHoveredCountry(name)
              else setHoveredCountry(lockedCountry) // keep showing locked country
            }
          }}
          setHoverRegion={(name, isRightClick) => {
            if (isRightClick) {
              setLockedRegion(prev => (prev === name ? null : name))
            } else {
              if (!lockedRegion) setHoveredRegion(name)
              else setHoveredRegion(lockedRegion) // keep showing locked region
            }
          }}
          countryToRegion={countryToRegion}
          availableCountries={availableCountries}
          regionsMap={regionsMap}
          onCountryClick={handleCountryClick}
        />
      </div>

      {/* Tap-to-dismiss backdrop (visible on phones only, see MapPage.css) */}
      {panelOpen && (
        <div
          className="map-page-backdrop"
          onClick={() => setPanelOpen(false)}
        />
      )}

      {/* SidePanel (renders its own collapsed handle when closed) */}
      <SidePanel
        hoveredCountry={hoveredCountry}
        countryInfo={countryInfo}
        regionsMap={regionsMap}
        panelOpen={panelOpen}
        togglePanel={() => setPanelOpen((prev) => !prev)}
        setLockedCountry={setLockedCountry}

        lockedCountry={lockedCountry}
        lockedRegion={lockedRegion}
        setLockedRegion={setLockedRegion}
        hoveredRegion={hoveredRegion}
      />

    </div>
  )
}

export default MapPage
